import { useEffect, useState } from "react";
import PropTypes from "prop-types";

// @mui material components
import { Grid, MenuItem, Autocomplete, TextField } from "@mui/material";
import { Controller } from "react-hook-form";

// Material Dashboard 2 PRO React components
import MDBox from "../../../../../components/MDBox";
import MDTypography from "../../../../../components/MDTypography";
import MDInput from "../../../../../components/MDInput";

// NewProduct page components
import FormField from "../FormField";
import sectionService from "../../../../../services/sectionService";

// Componente: Paso 1 - Información básica
function NewsletterInfo({ control, errors, isEdit }) {
  const [sections, setSections] = useState([]);

  useEffect(() => {
    const fetchSections = async () => {
      try {
        const response = await sectionService.getAll();
        setSections(response.data);
      } catch (error) {
        console.error("Error fetching sections:", error);
      }
    };
    fetchSections();
  }, []);

  return (
    <MDBox>
      <MDTypography variant="h5" mb={3}>
        Sobre el newsletter
      </MDTypography>
      <Grid container spacing={3}>
        <Grid item xs={12} sm={6}>
          <Controller
            name="email"
            control={control}
            render={({ field }) => (
              <FormField
                {...field}
                label="Email"
                error={!!errors.email}
                helperText={errors.email?.message}
              />
            )}
          />
        </Grid>
        <Grid item xs={12} sm={6}>
          <Controller
            name="status"
            control={control}
            render={({ field }) => (
              <MDInput
                {...field}
                select
                label="Estado"
                fullWidth
                error={!!errors.status}
                helperText={errors.status?.message}
              >
                <MenuItem value="activo">Activo</MenuItem>
                <MenuItem value="inactivo">Inactivo</MenuItem>
              </MDInput>
            )}
          />
        </Grid>
        <Grid item xs={12}>
          <Controller
            name="sections"
            control={control}
            render={({ field: { value, onChange, ...field } }) => (
              <Autocomplete
                multiple
                options={sections}
                getOptionLabel={(option) => option.name || ""}
                value={sections.filter((s) => value.includes(s._id))}
                onChange={(event, newValue) => {
                  onChange(newValue.map((item) => item._id));
                }}
                renderInput={(params) => (
                  <TextField
                    {...params}
                    label="Secciones"
                    error={!!errors.sections}
                    helperText={errors.sections?.message}
                    variant="standard"
                  />
                )}
              />
            )}
          />
          <MDTypography variant="caption" color="text">
            Si no se selecciona ninguna sección, se suscribirá a todas por defecto.
          </MDTypography>
        </Grid>
      </Grid>
    </MDBox>
  );
}

NewsletterInfo.propTypes = {
  control: PropTypes.object.isRequired,
  errors: PropTypes.object.isRequired,
  isEdit: PropTypes.bool.isRequired,
};

export default NewsletterInfo;